import Swal from 'sweetalert2';

export const modal = Swal.mixin({
  customClass: {
    container: 'modal',
    confirmButton: 'modal__button modal__button--confirm',
    cancelButton: 'modal__button modal__button--cancel',
  },
  reverseButtons: true,
});
